import type { DocumentModel } from '@ctw/shared/api/fhir/models/document';
import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import { RelatedDocumentNarratives } from '@ctw/shared/content/related-documents/related-document-narratives';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const documentReferenceDrawerAction: UseResourceDrawerOpenDrawerArgs<'DocumentReference'>['action'] =
  ({ model }) => ({
    label: 'Document',
    title: model.title,
    enableDismissAndReadActions: true,
    content: {
      body: <DocumentReferenceDrawerBody model={model} />,
    },
  });

interface DocumentReferenceDrawerBodyProps {
  model: DocumentModel;
}

/**
 * The body of the DocumentReference drawer, factored out so other drawer actions (e.g. the
 * Binary drawer, which resolves to a DocumentReference at render time) can render the same
 * details + related-documents layout without duplicating the shape.
 */
export const DocumentReferenceDrawerBody = ({ model }: DocumentReferenceDrawerBodyProps) => (
  <div className={tw`flex flex-col gap-5`}>
    <ContentCard
      variant="focal"
      title="Details"
      content={{
        header: <ResponsiveSourceDocumentLink model={model} />,
      }}
    >
      <DefinitionList items={documentData(model)} />
    </ContentCard>
    {model.binaryId && <RelatedDocumentNarratives key={model.binaryId} binaryId={model.binaryId} />}
  </div>
);

const documentData = (document: DocumentModel) => [
  { label: 'Encounter Date', value: document.encounterDate },
  { label: 'Date Retrieved', value: document.dateCreated },
  { label: 'Author', value: document.custodian },
];
